var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"window",staticClass:"bay-window",attrs:{"href":_vm.getHref()}},[_c('img',{attrs:{"src":_vm.data.picture,"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33dae16b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bayWindow/Index.vue
// module id = null
// module chunks = 